// Centralized session/auth helpers — used by interceptor, poller, sidebar logout.

let logoutInFlight = false;

export const LOGOUT_REASONS = {
  EXPIRED: 'Your session has expired. Please sign in again.',
  REVOKED: 'You were logged out from another device.',
  MANUAL:  'You have been logged out.',
  GENERIC: 'Your session has ended. Please sign in again.'
};

function clearAuth() {
  localStorage.removeItem('ownerToken');
  localStorage.removeItem('ownerUser');
}

// Called by axios interceptor / poller / SSE handler when the current
// session is no longer valid. Idempotent — safe to call multiple times.
export function forceLogout(reason = LOGOUT_REASONS.GENERIC) {
  if (logoutInFlight) return;

  // Already on the login page — just stash the reason, don't redirect.
  if (window.location.pathname === '/login') {
    if (reason) sessionStorage.setItem('logoutReason', reason);
    return;
  }

  logoutInFlight = true;
  sessionStorage.setItem('logoutReason', reason);

  // Tell the app to show the modal.
  window.dispatchEvent(new CustomEvent('session_ended', { detail: { reason } }));

  // Hard fallback in case the modal handler fails.
  setTimeout(() => {
    clearAuth();
    if (window.location.pathname !== '/login') {
      window.location.replace('/login');
    }
  }, 2200);
}

export function completeLogout() {
  clearAuth();
  window.location.replace('/login');
}

// Translate a 401 error message into a friendly reason.
export function reasonFromError(err) {
  const msg = (err?.response?.data?.message || '').toLowerCase();
  if (msg.includes('revoked')) return LOGOUT_REASONS.REVOKED;
  if (msg.includes('expired')) return LOGOUT_REASONS.EXPIRED;
  return LOGOUT_REASONS.GENERIC;
}
